import { styled, Flex, selectTheme } from '@creditas-ui/react';

const OptionItem = styled(Flex)`
  width: 100%;
  cursor: pointer;
  box-sizing: border-box;
  font-family: ${selectTheme('dropdown.options.item.fontFamily')};
  padding: ${selectTheme('dropdown.options.item.padding')};
  font-size: ${selectTheme('dropdown.options.item.fontSize')};
  color: ${selectTheme('dropdown.options.item.color')};
  background: ${selectTheme('dropdown.options.backgroundColor')};
  &:hover {
    background: ${selectTheme('dropdown.options.item.hover.backgroundColor')};
  }
  &:first-of-type {
    border-top-left-radius: ${selectTheme('dropdown.options.item.first.borderRadius')};
    border-top-right-radius: ${selectTheme('dropdown.options.item.first.borderRadius')};
  }
  &:last-child {
    border-bottom-left-radius: ${selectTheme('dropdown.options.item.last.borderRadius')};
    border-bottom-right-radius: ${selectTheme('dropdown.options.item.last.borderRadius')};
  }
`;

export { OptionItem };
